module.exports = __webpack_public_path__ + "static/media/redux-logo.c8f44df3.png";